import { cn } from "@/lib/utils";
import { useUiTranslations } from "@/hooks/use-ui-translations";

const SEASONS = ["summer", "winter", "spring", "autumn"] as const;

interface SeasonFilterProps {
  selected: string | null;
  onSelect: (season: string | null) => void;
}

export function SeasonFilter({ selected, onSelect }: SeasonFilterProps) {
  const { t } = useUiTranslations();

  return (
    <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
      <button
        onClick={() => onSelect(null)}
        className={cn(
          "shrink-0 rounded-full border px-4 py-1.5 text-sm font-medium transition-colors",
          selected === null
            ? "border-primary bg-primary text-primary-foreground"
            : "border-border bg-card text-muted-foreground hover:bg-accent hover:text-accent-foreground"
        )}
      >
        {t("filter.season")}
      </button>
      {SEASONS.map((s) => (
        <button
          key={s}
          onClick={() => onSelect(selected === s ? null : s)}
          className={cn(
            "shrink-0 rounded-full border px-4 py-1.5 text-sm font-medium transition-colors",
            selected === s
              ? "border-primary bg-primary text-primary-foreground"
              : "border-border bg-card text-muted-foreground hover:bg-accent hover:text-accent-foreground"
          )}
        >
          {t(`season.${s}`)}
        </button>
      ))}
    </div>
  );
}
